import { useMutation, useQueryClient } from '@tanstack/react-query'
import api, { withAuthenticatedRequest } from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'
import { TypeContratoServico } from '@/types/contrato-servico'

export function useCreateAgreementUser() {
  const queryClient = useQueryClient()

  const token = useAccessToken()
  return useMutation({
    mutationFn: async ({ contracts, email }: { contracts: TypeContratoServico[]; email: string }) => {
      const body = {
        contracts,
        email: email
      }

      if (!body.contracts || !body.email) {
        throw new Error('Campos obrigatórios ausentes')
      }

      const response = await api.post(`/agreement/vincular/user`, body, withAuthenticatedRequest(token))

      if (!response.data) {
        throw new Error('Erro ao criar contrato')
      }
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
    }
  })
}
